import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { usePolicy } from '../../../../../hooks/usePolicy'
import { ADMIN_ROUTES } from '../../../../../constants'
import { fsExcludeClass } from '../../../../../utils/fsExclude'
import { useClientAccountsActions } from './ClientAccountsTableContext'

function AccountNameCell ({ value, row }) {
  const { editing } = useClientAccountsActions()
  const canEditAccounts = usePolicy('admin_view_accts')
  const accountId = row.original?.accountId
  const cn = `__acct-cell ${fsExcludeClass}`

  if (canEditAccounts && !editing) {
    return (
      <div className={cn}>
        <Link to={`${ADMIN_ROUTES.ACCOUNTS}/${accountId}`}>{value || '--'}</Link>
      </div>
    )
  }
  return (
    <div className={cn}>
      <span>{value || '--'}</span>
    </div>
  )
}

AccountNameCell.propTypes = {
  value: PropTypes.any,
  row: PropTypes.any
}

export default AccountNameCell
